import React, { Component } from 'react'

const style = {
    padding: 0,
    paddingTop: 25,
    background: '#f1f2f7',
    paddingBottom: 60,
    minHeight: 'calc(100vh - 60px)'
}

class PageWrapper extends Component {
    render() {
        return <div style={style}>{this.props.children}</div>
    }
}

export default PageWrapper
